import { SDKError } from './sdk_error'
import { STATUS_TYPES } from '../constant/status.enum'
import { ERROR_TYPES } from './sdk_error/constant/error-types.enum'
import lodash from 'lodash'

const isSDKError = (errObject) => {
  return (errObject instanceof SDKError) && errObject.serialize
}

export class NodejsSDKModule {
  constructor({ name, version, description }) {
    this.name = name,
    this.version = version,
    this.description = description
    this.actions = {}
    this.apis = {}
    this._invokeId = 0
    this._reqJsonSDKId = 0
  }

  _genId(id) {
    if (id >= 2100000000 || id < 0) {
      id = 0
    }
    return ++id
  }

  _genInvokeId() {
    this._invokeId = this._genId(this._invokeId)
    return this._invokeId
  }

  _genReqJsonSDKId() {
    this._reqJsonSDKId = this._genId(this._reqJsonSDKId)
    return this._reqJsonSDKId
  }

  registerModule() {
    const globalInface = typeof window === 'object' ? window : global
    const firstModule = {}
    firstModule[this.name] = this
    globalInface.modules ? globalInface.modules[this.name] = this : globalInface.modules = firstModule
    return this
  }

  registerRawApi(action_name, action_cb) {
    if (!this.actions) {
      this.actions = {}
    }
    this.actions[action_name] = action_cb.bind(this)
    return this
  }

  registerSDKApi(api_name, api = () => { throw new Error('need to implement api') }) {
    if (!this.apis) {
      this.apis = {}
    }
    this.apis[api_name] = api || (() => {throw new Error('need to implement api')})
    return this
  }

  _getAction(action_name) {
    const _action = this.actions[action_name]
    if (!_action) {
      throw new SDKError().failedAction(`cannot found action ${action_name} in ${this.name}`)
    }
    return _action
  }

  getModuleApi(module_name) {
    const globalInface = typeof window === 'object' ? window : global
    return globalInface && globalInface.modules && globalInface.modules[module_name] && globalInface.modules[module_name].apis ? globalInface.modules[module_name].apis : {}
  }

  _getActionObject(action_name = 'UNKNOWN_ACTION', _req_id = 1, _sync = false, _customFrom = undefined) {
    return (resObject, status_code = STATUS_TYPES.INFACE_FAIL, error_object, data_object = {}) => {
      const responseObject = {
        _action: action_name,
        _from: _customFrom || this.name,
        _sync: _sync,
        _req_id,
        _data: {}
      }

      const errorSerialize = (errObj) => {
        if (!isSDKError(errObj)) {
          return {
            ...errObj
          }
        }

        return {
          code: ERROR_TYPES.SDK_ERROR.CODE,
          ...errObj.serialize()
        }
      }

      const resObjectType = typeof resObject

      if (isSDKError(resObject)) {
        responseObject['_error'] = errorSerialize(resObject)
      } else if (resObjectType === 'object' && resObject !== null) {
        responseObject['_data'] = resObject
      } else {
        if (typeof resObject === 'undefined') {
          responseObject['_data'] = {}
        } else {
          responseObject['_data'] = { value: resObject }
        }
      }

      if (error_object) {
        responseObject['_error'] = errorSerialize(error_object)
        responseObject['_data'] = data_object
        if (!lodash.isEmpty(resObject)) {
          const other = isSDKError(resObject) ? resObject.serialize() : resObject
          responseObject['_error'].other = responseObject['_error'].other && other ? { ...other, ...responseObject['_error'].other } : other || {}
        }
      }

      return responseObject
    }
  }

  _getInvokeObject(action_name, payload) {
    const invokeObject = {
      _action: action_name,
      _from: this.name,
      _invoke: this._genInvokeId(),
      _payload: payload,
    }

    return invokeObject
  }

  _getRequestJsonSDKObject(target, action, payload) {
    const requestJsonObject = {
      _to: target,
      _from: this.name,
      _action: action,
      _req_id: this._genReqJsonSDKId(),
      _data: payload,
      _sync: true
    }

    return requestJsonObject
  }

  async onListener({ target, reqId, payload, channel, fromInfo, broadcast }) {
    const _actionType = payload._action
    const _data = payload._data
    const _from = payload._from || 'inface'
    const _reqId = reqId
    const _sync = payload._sync
    const _to = target
    const _channel = channel
    const sendToTarget = (target_name, _req) => { broadcast(target_name, _req) }
    const sendToGame = (_actionType = 'UNKNOWN_ACTION', _req, _status, _error_obj, _reqIdValue = _reqId, _syncValue = false, _customFrom) => sendToTarget('game', this._getActionObject(_actionType, _reqIdValue, _syncValue, _customFrom)(_req, _status, _error_obj))
    const sendToSDK = (sdk_name = 'UNKNOWN_SDK', _actionType = 'UNKNOWN_ACTION', _req, _status, _error_obj, _reqIdValue = _reqId, _syncValue = false) => {
      if (sdk_name) {
        sendToTarget(sdk_name, this._getActionObject(_actionType, _reqIdValue, _syncValue)(_req, _status, _error_obj))
      }
    }
    
    const sendToGameAlias = (sdk_name, action_name, data = {}, error_obj, syncValue = false) => {
      if (sdk_name && action_name) {
        sendToGame(action_name, data, STATUS_TYPES.INFACE_SUCCESS, error_obj, undefined, syncValue, sdk_name)
      }
    }
    
    const okGameAction = (_actionType, _req, _error_obj) => {
      return sendToGame(_actionType, _req, STATUS_TYPES.INFACE_SUCCESS, _error_obj)
    }

    const failGameAction = (_actionType, _req, _error_obj) => {
      return sendToGame(_actionType, _req, STATUS_TYPES.INFACE_FAIL, _error_obj)
    }

    const okAction = (_to, _actionType, _req, _error_obj) => {
      return sendToSDK(_to, _actionType, _req, STATUS_TYPES.INFACE_SUCCESS, _error_obj)
    }

    const failAction = (_to, _actionType, _req, _error_obj) => {
      return sendToSDK(_to, _actionType, _req, STATUS_TYPES.INFACE_FAIL, _error_obj)
    }

    const ok = (_res, _error_obj, _error_data = {}) => {
      sendToTarget(_from, this._getActionObject(_actionType, _reqId, _sync)(_res, STATUS_TYPES.INFACE_SUCCESS, _error_obj, _error_data))
    }
    const fail = (_error_obj ) => {
      sendToTarget(_from, this._getActionObject(_actionType, _reqId, _sync)({}, STATUS_TYPES.INFACE_FAIL, _error_obj))
    }

    const invokeGameAction = (_actionType, _req) => {
      return _channel.invokeAction(_to, this._getInvokeObject(_actionType, _req))
    }

    const requestJsonSDK = (_to, _actionType, _req) => {
      return _channel.requestJsonSDK(this._getRequestJsonSDKObject(_to, _actionType, _req), fromInfo.connection)
    }

    try {
      const _actionFunction = this._getAction(_actionType)
      await _actionFunction.bind(this.actions)({
        ok,
        fail,
        sendToGame,
        sendToSDK,
        okGameAction,
        failGameAction,
        okAction,
        failAction,
        invokeGameAction,
        sendToGameAlias,
        requestJsonSDK,
        getModuleApi: this.getModuleApi,
        SDKError,
        from: _from
      }, _data)
    } catch (error) {
      sendToTarget(_from, this._getActionObject(_actionType, _reqId, _sync)({}, STATUS_TYPES.INFACE_FAIL, error))
    }
  }
}
